import React, { useEffect, useContext } from 'react'
import { ModalActions } from '../common/modal/Modal'
import { Button } from '@fluentui/react-components'
import { t } from '../../i18n/i18n'
import { Grid } from '../common/grid/Grid'
import { GridItem } from '../common/grid/GridItem'
import { UseFormReturn } from 'react-hook-form'
import { Process, ProcessOwnerDto } from '../../api/schemas/schema'
import { Text } from '../common/text/Text'
import { DemandAnalysisProcessOwnerPicker } from './DemandAnalysisProcessOwnerPicker'
import { DataContext } from '../../context/DataContext'
import { DemandAssessmentFormValues } from './DemandAssessmentForm'

type ProcessOwnerFormProps = {
   demandAssessmentForm: UseFormReturn<DemandAssessmentFormValues>
   prevStep: () => void
   processes: Process[]
   defaultProcessOwners: ProcessOwnerDto[]
}
export const ProcessOwnerForm = ({ demandAssessmentForm, prevStep, processes, defaultProcessOwners }: ProcessOwnerFormProps) => {
   const {
      watch,
      setValue,
      formState: { isSubmitting },
   } = demandAssessmentForm
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state
   useEffect(() => {
      setValue(
         'demandAnalysisProcessOwners',
         watch('processes').map((process) => {
            const processObj = processes.find((p) => p.text === process)
            const defaultPo = defaultProcessOwners?.find((poConn) => poConn.processes.find((po) => po.text === process))

            const hasDefaultPo = defaultPo?.userAccount || defaultPo?.ownerFreeText

            return {
               process: processObj,
               processId: processObj.id,
               userAccount: defaultPo?.userAccount ?? (hasDefaultPo ? null : userAccount),
               userAccountId: defaultPo?.userAccount?.id ?? (hasDefaultPo ? null : userAccount.id),
               ownerFreeText: defaultPo?.ownerFreeText ?? null,
            }
         })
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [defaultProcessOwners])

   return (
      <Grid gap="L">
         <GridItem size="12/12">
            <Text>{t('ProcessOwnerForDemandAssessmentText')}</Text>
         </GridItem>
         <>
            {watch('processes')?.map((process) => (
               <GridItem key={process} size="12/12">
                  <DemandAnalysisProcessOwnerPicker demandAssessmentForm={demandAssessmentForm} processes={processes} process={process} />
               </GridItem>
            ))}
         </>
         <GridItem size="12/12">
            <ModalActions>
               <Button onClick={prevStep} appearance="secondary">
                  {t('Back')}
               </Button>

               <Button type="submit" appearance="primary" disabled={isSubmitting}>
                  {t('CreateAssessment')}
               </Button>
            </ModalActions>
         </GridItem>
      </Grid>
   )
}
